
import { createApp } from 'vue'
import App from './App.vue'

import router from '@/router/router'
import store from '@/store/store'
import 'bootstrap'
import './assets/sass/app.scss'
import 'vue-multiselect/dist/vue-multiselect.css'
import Toaster from "@meforma/vue-toaster";

createApp(App)
    .use(store)
    .use(router)
    .use(Toaster, {
        position: 'top-right',
        delay: 0,
        timeOut: 2000,
        hideDuration: 2500
    })
    .mount('#app')
